import React, {
    useState,
    useEffect
} from 'react';

import styled, {css} from "styled-components";



const Wrapper = styled.div.attrs(props => ({
    minWidth: props.minWidth || "320px"
}))`
    display: flex;
    flex-flow: column nowrap;
    margin: 0 0 8px 0;
    min-width: ${props => props.minWidth}; 

    ${props => props.theme.mediaQueries.medium}{
        margin: 0 0 16px 0;
    }
`

const Label = styled.label`
    margin-bottom: 0px;
    display: inline-block;
    max-width: 100%;
    font-weight: 400;
    background: white
`

const SvgContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 8px;
    padding: 16px;
    //height: 64px;
    height: 56px;
    border: 1px solid #ECECE7;

    ${props => props.active && css`
        padding: 8px 16px;
    `}

    ${props => props.boarder && css`
        border-color: ${props => props.theme.codanColors.color};
        border-width: 1px;
        border-style: solid;
        padding: 8px 16px;
    `}

    ${props => props.error && css`
        border-color: ${props => props.theme.codanColors.codanErrorRed};
        border-width: 1px;
        border-style: solid;
        padding: 8px 16px;
    `}

    :hover {
        transition: all 100ms ease-in-out;
        border-color: ${props => props.theme.codanColors.color};
        border-width: 1px;
        border-style: solid;
    }
`

const InputContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
`

const InputLabel = styled.div`
    z-index: 1;
    transition: all 150ms ease;
    // left: 0;
    // bottom: 0;
    // right: 0;
    // top: 0; 
    position: absolute;
    line-height: 2rem;
    font-size: 1.33rem;

    ${props => props.theme.mediaQueries.medium}{
        font-size: 0.8rem;
        line-height: 1.2;
    }

    ${props => props.active && css`
        line-height: 1.3rem;
        font-size: 0.9rem;
        position: static;
        opacity: 0.6;

        ${props => props.theme.mediaQueries.medium}{
            font-size: 0.55rem;
            line-height: 0.65rem;
        }
    `}
`

const Input = styled.input`
    font-family: inherit;
    transition-delay: 150ms;
    transition: opacity 150ms ease-in-out;
    line-height: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 0px;
    padding: 0;
    width: 100%;
    border-left-style: none;
    border-left-width: 0;
    border-bottom-style: none;
    border-bottom-width: 0;
    border-right-style: none;
    border-right-width: 0;
    border-top-style: none;
    border-top-width: 0;
    background-color: transparent;
    outline: 0;
    margin: 0;
    opacity: 0;
    

    ${props => props.active && css`
        opacity: 1;
        font-size: 1.3rem;
        line-height: 2rem;

        ${props => props.theme.mediaQueries.medium}{
            font-size: 0.8rem;
            line-height: 1.2rem;
        }
    `}  
`

const Error = styled.p`
    color: ${props => props.theme.codanColors.codanErrorRed};
    font-size: 0.9rem;
    margin: 0; 

    ${props => props.theme.mediaQueries.medium}{
        font-size: 0.55rem;
    }
`

const LabelledInputValidatedNyKredit = ({
    type,
    pattern,
    name,
    onChange,
    errors,
    values,
    isStrong,
    labelText,
    svg,
    optionalFunction,
    maxlength,
    ...props
}) => {
    const [active, setActive] = useState(false);
    const [boarder, setBoarder] = useState(false);
    const [value, setValue] = useState(values[name]);

    useEffect(() => {
        if (values[name]) {
            setActive(true)
        }
    },[active])

    useEffect(() => {
        const addAutoValueToInput = () => {
            if (!optionalFunction) {
                if (values[name]) {
                    setActive(true)
                }

                setValue(values[name])
            }

        }

        addAutoValueToInput();

    }, [values[name]])

    const handelFocus = () => {
        setActive(true);
        setBoarder(true);
    }

    const handelBlure = () => {
        setActive(false);
        setBoarder(false);
    }

    const handelChange= (event) => {
        if (optionalFunction) {
            const value = optionalFunction(event.target.value)
            setValue(value)
            event.target.value = value
        } else {
            setValue(event.target.value)
        }
        
        //for validation
        onChange(event);

        //internal value
        // setValue(event.target.value)


    }

    return (
        <Wrapper {...props}>
            <Label>
                <SvgContainer active={active} boarder={boarder} error={errors[name]}>
                    {svg}

                    <InputContainer>
                        <InputLabel 
                            active={active}
                            {...props}
                        >
                            {labelText}
                        </InputLabel>
                        <Input
                            onFocus={handelFocus} 
                            onBlur={handelBlure}
                            type={type}
                            pattern={pattern}
                            name={name}
                            onChange={handelChange}
                            value={value || ''}
                            active={active}
                            maxLength={maxlength}
                        />
                    </InputContainer>
                </SvgContainer>
            </Label>
            {errors[name] && (
                <Error>{errors[name]}</Error>
            )}
        </Wrapper>

    )
}

export default LabelledInputValidatedNyKredit;